export default __webpack_public_path__ + "static/media/1032.f76e0b5f.png";